import _ from "lodash";
import update from "immutability-helper";
import { goToAdminRoute, goToBack } from "modules/NavigationModule";
import { getCurriculumProgramLabel } from "Platform/modules/PlatformUtils";
import {
  getAdminMenuItemsMemoize,
  getAdminMenuUid,
  removeIBPrefixFromCurriculumType,
  getSidebarMenuTreeStructure,
  getConfigurationAccess,
  RESTRICTED_NODES_OUTSIDE_CURRENT_ACADEMIC_YEAR,
  getAreOperationsDisabledForLocalisation,
  getLanguageLabel,
  getFilteredMenuItemsWrtRnP,
} from "Administrator/modules/Utils";
import { goToRelativeRoute } from "modules/Services";
import { getCourseUnitPlanCountOfSubjectQuery } from "modules/CommonQuery";
import { getCurrentCurriculumProgramType } from "modules/CommonSelectors";
import client from "lib/apolloClient/client";
import { getAdminPortalNodeVisibilityStatusByUID } from "Administrator/modules/Utils";

import ACLStore from "lib/aclStore";
import { MODULES } from "lib/staffPermissionUtils";

import {
  getSelectedAcademicYear,
  getIsPreviousAcademicYearSelected,
  getOrganizationCurriculumPrograms,
} from "modules/CommonSelectors";
import { i18n } from "lib/i18n";
import ACLStorage from "lib/aclService";

export const NAME = "administrator";

export const UPDATE_DYNAMIC_HEADER_TITLES =
  "UPDATE_DYNAMIC_HEADERS_TITLES" + " " + NAME;

export const SET_PARENT_ID = "SET_PARENT_ID" + " " + NAME;
export const SET_CHILD_ID = "SET_CHILD_ID" + " " + NAME;
export const SET_SUB_CHILD_ID = "SET_SUB_CHILD_ID" + " " + NAME;
export const INIT_ROUTES = "INIT_ROUTES" + " " + NAME;
export const UPDATE_SUBJECT_FILTERS = "UPDATE_SUBJECT_FILTERS" + " " + NAME;
export const UPDATE_GRADE_FILTERS = "UPDATE_GRADE_FILTERS" + " " + NAME;
export const RESET_SUBJECT_FILTERS = "RESET_SUBJECT_FILTERS" + " " + NAME;
export const UPDATE_EE_SUBJECT_FILTERS =
  "UPDATE_EE_SUBJECT_FILTERS" + " " + NAME;
export const UPDATE_ADD_EE_SUBJECT_FILTERS =
  "UPDATE_ADD_EE_SUBJECT_FILTERS" + " " + NAME;
export const SHOW_CURRENTLY_WORKING_IN_ANOTHER_YEAR_BANNER =
  "SHOW_CURRENTLY_WORKING_IN_ANOTHER_YEAR_BANNER" + " " + NAME;
export const SHOW_COMMON_ACROSS_YEAR_WARNING =
  "SHOW_COMMON_ACROSS_YEAR_WARNING" + " " + NAME;
export const SET_IS_SIDEBAR_VISIBLE = "SET_IS_SIDEBAR_VISIBLE" + " " + NAME;
export const SET_SCROLL_POSITION = "SET_SCROLL_POSITION" + " " + NAME;
export const SET_IS_LOADING_STATE = "SET_IS_LOADING_STATE" + " " + NAME;
export const UPDATE_IBIS_SESSION_DETAILS =
  "UPDATE_IBIS_SESSION_DETAILS" + " " + NAME;
export const UPDATE_SELECTED_TAB_VALUE =
  "UPDATE_SELECTED_TAB_VALUE" + " " + NAME;
export const SET_WARNING_DIALOG_DETAILS =
  "SET_WARNING_DIALOG_DETAILS" + " " + NAME;
export const SET_TASK_PROGRESS = `SET_TASK_PROGRESS ${NAME}`;
export const REMOVE_TASK_PROGRESS = `REMOVE_TASK_PROGRESS ${NAME}`;

const EMPTY_OBJ = {};

// PURE ACTIONS
const CONTENT_CELL_WIDTH = 20;
const TITLE_CELL_WIDTH = 50;
const CELL_PADDING = 4;

export const setParentId = data => {
  return { type: SET_PARENT_ID, payload: data };
};

export const setChildId = data => {
  return { type: SET_CHILD_ID, payload: data };
};

export const setSubChildId = data => {
  return { type: SET_SUB_CHILD_ID, payload: data };
};

export const initRoutes = () => {
  return { type: INIT_ROUTES };
};

export const setWarningDialogDetails = data => {
  return { type: SET_WARNING_DIALOG_DETAILS, data };
};

export const setTaskProgress = payload => ({
  type: SET_TASK_PROGRESS,
  payload,
});

export const removeTaskProgress = payload => ({
  type: REMOVE_TASK_PROGRESS,
  payload,
});

export const updateParentId = parentId => {
  return (dispatch, getState) => {
    const curriculumProgramId = _.get(
      getState(),
      "platform.currentCurriculumProgram.id"
    );
    const uid = getAdminMenuUid({ curriculumProgramId, nodeId: parentId });
    dispatch(setParentId(uid));
  };
};

export const updateChildId = childId => {
  return (dispatch, getState) => {
    dispatch(setChildId(childId));
    const node = getAdminNode(childId);

    /**
     * HACK for skipping the permission check
     */

    if (
      _.includes(
        ["schoolSettingsTab", "accountSettingsTab"],
        _.get(getState(), "login.activeTab")
      )
    ) {
      return;
    }

    const perm = _.get(node, "perm", "");

    const permission = _.get(node, "permission", "");
    const isNodeVisible = ACLStorage.getModuleSettingsValue(permission);

    let isPermitted = ACLStore.can(perm) || isNodeVisible;

    if (childId?.includes("LEARNING_COURSE_SETUP")) {
      // For LEARNING_COURSE_SETUP we are not checking things on the basis of permission or perm
      isPermitted = true;
    }

    const isPermNegated = _.get(node, "isPermNegated", false);
    if (!node || (isPermNegated ? isPermitted : !isPermitted)) {
      dispatch(goToAdminRoute({ navigateType: "replace" }));
    }
  };
};

export const getAdminNodeByRouteName = route => {
  const adminMenuItems = getAdminMenuItemsMemoize();
  const nodes = _.get(adminMenuItems, "nodes", []);
  return _.find(nodes, item => item.route == route);
};

export const updateChildRoute = route => {
  return (dispatch, getState) => {
    const nodeItem = getAdminNodeByRouteName(route);
    if (nodeItem) {
      dispatch(updateChildId(nodeItem.id));
    }
  };
};

export const goToChildPath = ({ childId }) => {
  return (dispatch, getState) => {
    const { childId: oldChildId } = getState().administrator.routes;
    const oldChildNode = getAdminNode(oldChildId);
    const childNode = getAdminNode(childId);
    const childParentNode = getAdminNode(childNode.parent);

    let replacePath = "";
    if (oldChildNode) {
      replacePath = oldChildNode.route;
    }
    if (childNode) {
      const shouldPrefixParentNodeRoute =
        childParentNode?.route && childNode.prefixParentNodeRoute;

      const destinationRoute = shouldPrefixParentNodeRoute
        ? `./${childParentNode.route}/${childNode.route}`
        : `./${childNode.route}`;

      dispatch(
        goToRelativeRoute({
          route: destinationRoute,
          replacePath,
          type: "replace",
        })
      );
    }
  };
};

export const goToSubChildPath = ({ subChildId }) => {
  return (dispatch, getState) => {
    const { subChildId: oldSubChildId } = getState().administrator.routes;
    const oldChildNode = getAdminNode(oldSubChildId);
    const childNode = getAdminNode(subChildId);
    let replacePath = "";
    if (oldChildNode) {
      replacePath = _.get(oldChildNode, "route", "");
    }
    const newRoute = _.get(childNode, "route", "");
    if (childNode) {
      dispatch(
        goToRelativeRoute({
          route: `./${newRoute}`,
          replacePath,
          type: "replace",
        })
      );
    }
  };
};

export const goBackFromChild = ({ hasChild, isClickedFromHomeScreen }) => {
  return (dispatch, getState) => {
    const { parentId } = getState().administrator.routes;
    const curriculumProgramId = _.get(
      getState(),
      "platform.currentCurriculumProgram.id"
    );

    const uid = getAdminMenuUid({ curriculumProgramId, nodeId: parentId });
    const parentNode = getAdminNode(uid);

    if (parentNode) {
      const { route } = parentNode;
      // TODO: Find a better solution. If a folder is open then `hasChild` will be true
      if (hasChild) {
        dispatch(goToBack());
      } else {
        const replacePath = _.includes(route, "/")
          ? _.get(_.split(route, "/"), 0) // curriculum program id
          : route;

        // different path for teacher home page
        const updatedRoute = isClickedFromHomeScreen
          ? `${curriculumProgramId}/courses`
          : "";

        dispatch(
          goToRelativeRoute({
            replacePath,
            type: "replace",
            route: updatedRoute,
          })
        );
        dispatch(initRoutes());
      }
    }
  };
};

/*
  `uid` is added to all admin nodes. If a node is a child of curriculum program then the uid has the format: CURRICULUM_ID:NODE_ID,
  otherwise, nodeId is used as `uid`
  id cannot be modified as it's used in many places, hence `uid`.
*/
export const getAdminNode = uid => {
  const adminMenuItems = getAdminMenuItemsMemoize();
  if (_.isEmpty(adminMenuItems)) {
    getAdminMenuItemsMemoize.cache.clear();
  }
  let nodes = _.get(adminMenuItems, "nodes", []);
  nodes = getFilteredMenuItemsWrtRnP({ nodes });

  return _.find(nodes, {
    uid,
  });
};

export const getAdminNodesWithUpdatedChildren = (uid, curriculumProgramId) => {
  const node = getAdminNode(uid);
  if (!node || !curriculumProgramId) return node;
  return getUpdatedNodeChildren(node, curriculumProgramId);
};

const nodeChildrenMappings = {
  GENERAL_SETTINGS: ["ATTENDANCE_SETTINGS"],
  MODULE_SETTINGS_V2: [],
  USERS_AND_PERMISSIONS: [],
  PROGRAM_OTHER_SETTINGS: [],
};

const getUpdatedNodeChildren = (node, curriculumProgramId) => {
  const { id } = node;

  const pypAttendanceAccess = getConfigurationAccess({
    curriculumIds: [curriculumProgramId],
    moduleKey: MODULES.ATTENDANCE.id,
  });

  const pypProgrammeSettingsAccess = getConfigurationAccess({
    curriculumIds: [curriculumProgramId],
    moduleKey: MODULES.CURRICULUM_SETTINGS.id,
  });

  if (pypAttendanceAccess && !pypProgrammeSettingsAccess) {
    const finalChildren = _.includes(_.keys(nodeChildrenMappings), id)
      ? nodeChildrenMappings[id]
      : node.children;
    return { ...node, children: finalChildren };
  }

  return node;
};

export const getCourseUnitPlanCountOfSubject = async id => {
  const data = await client.query({
    query: getCourseUnitPlanCountOfSubjectQuery,
    variables: {
      id,
    },
    fetchPolicy: "network-only",
  });

  return {
    courseCount: _.get(data, "data.node.courseCount", 0),
    unitPlanCount: _.get(data, "data.node.unitPlanCount", 0),
  };
};

export const getAdminHeaderRootRouteLabel = ({
  organizationCurriculumPrograms,
  curriculumProgramId,
  t,
  parentId,
}) => {
  const defaultRootRoute = t("common:school_configurations");

  const currentCurriculumProgram =
    _.find(organizationCurriculumPrograms, { id: curriculumProgramId }) ?? {};

  return _.isEmpty(currentCurriculumProgram) ||
    _.includes(
      ["SCHOOL_SETUP", "SCHOOL_ANALYTICS", "STAFF_PERMISSIONS"],
      parentId
    )
    ? defaultRootRoute
    : getCurriculumProgramLabel({
        curriculumProgram: currentCurriculumProgram,
        shouldIncludeAcronym: true,
      });
};

export const getAdminParentNode = ({
  childId,
  getSubSection = false,
  curriculumProgramType,
}) => {
  const adminMenuItems = getAdminMenuItemsMemoize();
  const nodes = _.get(adminMenuItems, "nodes", []);
  const childNode = _.find(nodes, { id: childId });
  const parentNode = _.find(nodes, item => {
    const isCommonAcrossCurriculums = _.get(
      childNode,
      "isCommonAcrossCurriculums",
      false
    );

    let condition = _.includes(item.children, childId);

    // Adding additional check for curriculum program type if the node is common across curriculums
    if (
      isCommonAcrossCurriculums &&
      !_.isEmpty(item.curriculumPrograms) &&
      !_.isEmpty(curriculumProgramType)
    ) {
      condition =
        condition && _.includes(item.curriculumPrograms, curriculumProgramType);
    }

    return condition;
  });

  const { id, isSubsection } = parentNode || {};
  if (getSubSection || !isSubsection) return parentNode;
  return getAdminParentNodeMemoize({
    childId: id,
    getSubSection,
    curriculumProgramType,
  });
};

export const getAdminParentNodeMemoize = _.memoize(
  params => getAdminParentNode(params),
  params => JSON.stringify(params)
);

export const getNextMenuRoute = (
  parentId,
  curriculumProgramId,
  isCurrentAcademicYearSelected = true
) => {
  const parentMenu = getAdminNodesWithUpdatedChildren(
    parentId,
    curriculumProgramId
  );
  let route = "";
  if (parentMenu) {
    const children = _.get(parentMenu, "children", []);

    if (children.length > 0) {
      _.forEach(children, childId => {
        const childMenu = getAdminNodesWithUpdatedChildren(
          childId,
          curriculumProgramId
        );

        // This condition is added to restrict from returning route of the nodes specified in
        // RESTRICTED_NODES_OUTSIDE_CURRENT_ACADEMIC_YEAR outside the current academic year.
        // As they are disabled and not viewable in the sidebar, we should not return their route.
        if (
          !isCurrentAcademicYearSelected &&
          _.includes(RESTRICTED_NODES_OUTSIDE_CURRENT_ACADEMIC_YEAR, childId)
        ) {
          return true;
        }

        if (childMenu) {
          const hasChildren = !_.isEmpty(childMenu.children);
          if (hasChildren) {
            const tempRoute = getNextMenuRoute(
              childMenu.id,
              curriculumProgramId,
              isCurrentAcademicYearSelected
            );
            if (tempRoute) {
              route = tempRoute;
              return false;
            }
          } else {
            let isAccessAllowed;

            /**
             * Assumption: Only SIdebar nodes will be considered here.
             *
             * If sidebar node has permission and RnP is enabled, then check wrt RnP flow.
             * Else check wrt configuration flow.
             */
            if (childId?.includes("LEARNING_COURSE_SETUP")) {
              // For LEARNING_COURSE_SETUP we are not checking things on the basis of permission or perm
              isAccessAllowed = true;
            } else if (childMenu.permission) {
              isAccessAllowed = getAdminPortalNodeVisibilityStatusByUID({
                uid: childId,
                curriculumPrograms: [curriculumProgramId],
              });
            } else {
              const showChildMenu = ACLStore.can(childMenu.perm);

              isAccessAllowed = showChildMenu;
            }

            if (isAccessAllowed) {
              route = _.get(childMenu, "route", "");
              return false;
            }
          }
        }
      });
    }
  }
  return route;
};

export const prefixCurriculumName = ({ childId, curriculumProgramId }) => (
  dispatch,
  getState
) => {
  const organizationCurriculumPrograms = _.get(
    getState(),
    "platform.organizationCurriculumPrograms",
    []
  );

  const obj = _.find(organizationCurriculumPrograms, {
    id: curriculumProgramId,
  });

  if (!obj) return childId;

  return `${removeIBPrefixFromCurriculumType(obj.type)}_${childId}`;
};

export const updateChildRoutes = ({ routes, path, pathId, type = "push" }) => (
  dispatch,
  getState
) => {
  if (_.last(routes).path == path) {
    const curriculumProgramId = _.get(
      getState(),
      "platform.currentCurriculumProgram.id"
    );
    const selectedAcademicYear = getSelectedAcademicYear(getState());
    const isCurrentAcademicYearSelected = _.get(
      selectedAcademicYear,
      "isCurrentAcademicYear",
      true
    );
    const uid = getAdminMenuUid({ nodeId: pathId, curriculumProgramId });
    const route = getNextMenuRoute(
      uid,
      curriculumProgramId,
      isCurrentAcademicYearSelected
    );

    dispatch(
      goToRelativeRoute({
        route: route ? route : "../",
        type: route ? type : "push",
      })
    );
  }
};

export const updateSubjectFilters = data => {
  return {
    type: UPDATE_SUBJECT_FILTERS,
    data,
  };
};
export const updateGradeFilters = data => {
  return {
    type: UPDATE_GRADE_FILTERS,
    data,
  };
};
export const resetSubjectFilters = () => {
  return { type: RESET_SUBJECT_FILTERS };
};

export const updateEESubjectFilters = data => {
  return {
    type: UPDATE_EE_SUBJECT_FILTERS,
    data,
  };
};

export const updateAddEESubjectFilters = data => {
  return {
    type: UPDATE_ADD_EE_SUBJECT_FILTERS,
    data,
  };
};

export const applyCustomColumnStyles = ({ workSheet }) => {
  _.forEach(workSheet.columns, (column, columnNumber) => {
    let maxCellLength = 0;
    let tempCellLength = 0;
    column.eachCell(function (cell) {
      tempCellLength = cell.value ? cell.value.toString().length : 0;
      maxCellLength = _.max([tempCellLength, maxCellLength]);
    });
    if (columnNumber !== 0) {
      column.alignment = { vertical: "middle", horizontal: "left" };
      column.width = _.max([maxCellLength, CONTENT_CELL_WIDTH]);
    } else {
      column.alignment = {
        vertical: "middle",
        horizontal: "left",
        wrapText: true,
      };
      column.width = _.min([maxCellLength + CELL_PADDING, TITLE_CELL_WIDTH]);
    }
  });

  return workSheet;
};

export const handleAdminSidebarBackButtonClick = (skipRouteChange = false) => {
  return (dispatch, getState) => {
    const state = getState();
    const { subChildId } = _.get(state, "administrator.routes", {});
    const curriculumProgramType = getCurrentCurriculumProgramType(state);
    const item = getAdminNode(subChildId);
    const onLeaveInterceptor = _.get(item, "onLeaveInterceptor");

    if (typeof onLeaveInterceptor === "function") {
      const allowNavigation = onLeaveInterceptor({
        source: "SIDEBAR_BACK",
      });
      if (!allowNavigation) {
        return;
      }
    }
    const itemParent = _.get(item, "parent");
    const parentNode = getAdminNode(itemParent);
    let grandParent = _.get(parentNode, "parent");

    if (grandParent) dispatch(setSubChildId(itemParent));
    else {
      const itemRoute = _.get(item, "route");
      grandParent = getAdminParentNodeMemoize({
        childId: parentNode?.id,
        curriculumProgramType,
      });
      const route = getNextMenuRoute(grandParent?.uid || grandParent?.id);
      dispatch(setSubChildId(""));
      if (!skipRouteChange) {
        dispatch(
          goToRelativeRoute({
            route: itemRoute ? `../../${route}` : `../${route}`,
          })
        );
      }
    }
  };
};

export const handleAdminSidebarMenuItemClick = ({
  t,
  key,
  customMenuItemLabelsMap,
  readFromUserAndOrgLevel = false,
}) => {
  return (dispatch, getState) => {
    const state = getState();
    const { parentId, childId, subChildId } = _.get(
      state,
      "administrator.routes",
      {}
    );
    const currentPlannerElementSets = _.get(
      state,
      "platform.currentPlannerElementSets",
      []
    );
    const isCurrentAcademicYearSelected = _.get(
      state,
      "platform.academicYearSelected.isCurrentAcademicYear",
      true
    );

    const organizationCurriculumPrograms = getOrganizationCurriculumPrograms(
      state
    );
    const curriculumProgramIds = _.map(organizationCurriculumPrograms, "id");

    const adminMenuItems = getAdminMenuItemsMemoize();
    let { nodes } = adminMenuItems;
    nodes = getFilteredMenuItemsWrtRnP({
      nodes: adminMenuItems.nodes,
      isCurrentAcademicYearSelected,
    });

    const { nodes: menuItems } = getSidebarMenuTreeStructure({
      menuId: parentId,
      t,
      plannerElementSets: currentPlannerElementSets,
      nodes,
      customMenuItemLabelsMap,
      isCurrentAcademicYearSelected: isCurrentAcademicYearSelected,
      readFromUserAndOrgLevel,
      curriculumProgramIds,
    });
    const menuItemsByKey = _.keyBy(menuItems, "key");

    if (key) {
      const prevMenu = getAdminNode(subChildId || childId);
      const onLeaveInterceptor = _.get(prevMenu, "onLeaveInterceptor");

      if (typeof onLeaveInterceptor === "function") {
        const allowNavigation = onLeaveInterceptor({
          destinationNode: getAdminNode(key),
          source: "SIDEBAR_MENU",
        });
        if (!allowNavigation) {
          return;
        }
      }

      const currentMenu = _.get(menuItemsByKey, key, {});
      const currentMenuParentId = _.get(currentMenu, "parent", "");

      // check if the clicked menu is a slider menu
      const isSliderMenu = _.get(
        menuItemsByKey,
        [key, "isSliderSubmenu"],
        false
      );

      // check if the clicked menu is a subchild
      // if the clicked menu is a subsection inside a subtab then it is a subchild
      const isSubChild =
        _.get(
          menuItemsByKey,
          [currentMenuParentId, "isSliderSubmenu"],
          false
        ) ||
        _.get(
          menuItemsByKey,
          [currentMenuParentId, "isSubsectionInsideSubTab"],
          false
        );

      if (isSliderMenu) {
        const firstChildId = _.get(menuItemsByKey, [key, "children", 0], "");
        dispatch(setSubChildId(firstChildId));
      }

      if (isSubChild) {
        dispatch(goToSubChildPath({ subChildId: key }));
        dispatch(setSubChildId(key));
      } else {
        dispatch(goToChildPath({ childId: key }));
        dispatch(updateChildId(key));
      }
    }
  };
};

export const setIsCommonAcrossYearsWarningRequired = value => {
  return { type: SHOW_COMMON_ACROSS_YEAR_WARNING, payload: value };
};

export const setScrollPosition = value => {
  return { type: SET_SCROLL_POSITION, payload: value };
};

export const setIsAcademicYearStatusMessageVisible = value => {
  return {
    type: SHOW_CURRENTLY_WORKING_IN_ANOTHER_YEAR_BANNER,
    payload: value,
  };
};

export const updateIbisSessionDetails = data => {
  return { type: UPDATE_IBIS_SESSION_DETAILS, payload: data };
};

export const getLanguageDetails = () => {
  return (dispatch, getState) => {
    const state = getState();
    const programDataLanguages = _.get(
      state,
      "platform.currentCurriculumProgram.programDataLanguages",
      []
    );
    const switcherLanguage = i18n.language;
    const isSwitcherLngInProgramLng = _.includes(
      programDataLanguages,
      switcherLanguage
    );
    return {
      programDataLanguages,
      switcherLanguage,
      isSwitcherLngInProgramLng,
    };
  };
};

export const getDisabledOperationTooltip = ({
  t,
  operationLabel,
  datasetName,
}) => {
  return (dispatch, getState) => {
    const state = getState();

    const isPreviousAcademicYearSelected = getIsPreviousAcademicYearSelected(
      state
    );

    const { switcherLanguage, isSwitcherLngInProgramLng } = dispatch(
      getLanguageDetails()
    );

    const areOperationsDisabledForLocalisation = getAreOperationsDisabledForLocalisation(
      { isSwitcherLngInProgramLng }
    );

    if (isPreviousAcademicYearSelected) {
      return t(
        "schoolSetup:navigate_to_the_current_academic_year_to_edit_with_label",
        {
          label: operationLabel,
        }
      );
    }

    if (areOperationsDisabledForLocalisation) {
      return t(
        "academicSetup:switcher_language_not_in_program_language_tooltip",
        {
          datasetName,
          switcherLanguage: getLanguageLabel({ t, lng: switcherLanguage }),
        }
      );
    }
  };
};

// ------------------------------------
// Reducer Handlers
// ------------------------------------
const REDUCER_HANDLERS = {
  [SET_PARENT_ID]: (state, action) => {
    return update(state, { routes: { parentId: { $set: action.payload } } });
  },
  [SET_CHILD_ID]: (state, action) => {
    return update(state, { routes: { childId: { $set: action.payload } } });
  },
  [SET_SUB_CHILD_ID]: (state, action) => {
    return update(state, { routes: { subChildId: { $set: action.payload } } });
  },
  [INIT_ROUTES]: (state, action) => {
    return update(state, { routes: { $set: {} } });
  },
  [UPDATE_DYNAMIC_HEADER_TITLES]: (state, action) => {
    const params = action.data;
    Object.keys(params).map((key, index) => {
      state = update(state, {
        dynamicHeaderTitles: { [key]: { $set: params[key] } },
      });
    });
    return state;
  },
  [UPDATE_SUBJECT_FILTERS]: (state, action) => {
    const params = action.data;
    Object.keys(params).map(key => {
      state = update(state, {
        administratorSubjects: { filters: { [key]: { $set: params[key] } } },
      });
    });
    return state;
  },
  [UPDATE_EE_SUBJECT_FILTERS]: (state, action) => {
    const params = action.data;
    _.map(_.keys(params), key => {
      state = update(state, {
        eeSubjectsList: { filters: { [key]: { $set: params[key] } } },
      });
    });
    return state;
  },
  [UPDATE_ADD_EE_SUBJECT_FILTERS]: (state, action) => {
    const params = action.data;
    Object.keys(params).map(key => {
      state = update(state, {
        addEESubjectsModal: { filters: { [key]: { $set: params[key] } } },
      });
    });
    return state;
  },
  [RESET_SUBJECT_FILTERS]: state => {
    state = update(state, {
      administratorSubjects: {
        filters: { $set: initialState.administratorSubjects.filters },
      },
    });
    return state;
  },
  [UPDATE_GRADE_FILTERS]: (state, action) => {
    const params = action.data;
    Object.keys(params).map(key => {
      state = update(state, {
        administratorGrades: { filters: { [key]: { $set: params[key] } } },
      });
    });
    return state;
  },
  [SHOW_CURRENTLY_WORKING_IN_ANOTHER_YEAR_BANNER]: (state, action) => {
    return update(state, {
      isAcademicYearStatusMessageVisible: { $set: action.payload },
    });
  },
  [SHOW_COMMON_ACROSS_YEAR_WARNING]: (state, action) => {
    return update(state, {
      isCommonAcrossYearsWarningRequired: { $set: action.payload },
    });
  },
  [SET_IS_SIDEBAR_VISIBLE]: (state, action) => {
    return update(state, {
      isSidebarRequired: { $set: action.payload },
    });
  },
  [SET_SCROLL_POSITION]: (state, action) => {
    return update(state, {
      scrollPosition: { $set: action.payload },
    });
  },
  [SET_IS_LOADING_STATE]: (state, action) => {
    const key = action.payload.key;
    const value = action.payload.value;

    return update(state, {
      isLoading: { [key]: { $set: value } },
    });
  },
  [UPDATE_IBIS_SESSION_DETAILS]: (state, action) => {
    return update(state, {
      ibisSessionDetails: { $set: action.payload },
    });
  },
  [UPDATE_SELECTED_TAB_VALUE]: (state, action) => {
    return update(state, {
      selectedTabValue: { $set: action.data },
    });
  },
  [SET_WARNING_DIALOG_DETAILS]: (state, action) => {
    return update(state, {
      dialogDetails: { $set: action.data },
    });
  },
  [SET_TASK_PROGRESS]: (state, action) => {
    const { id, ...rest } = action.payload;

    if (!state.taskProgress[id]) {
      return update(state, {
        taskProgress: {
          [id]: { $set: { ...rest, pollingStartTime: Date.now() } },
        },
      });
    }

    return update(state, {
      taskProgress: { [id]: { $merge: rest } },
    });
  },
  [REMOVE_TASK_PROGRESS]: (state, action) => {
    const { id } = action.payload;
    return update(state, {
      taskProgress: { $unset: [id] },
    });
  },
};

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  isAcademicYearStatusMessageVisible: true,
  isCommonAcrossYearsWarningRequired: false,
  isDrawerOpen: false,
  routes: {},
  permissionGroups: [
    "Dashboards",
    "AdminPortal",
    "TeacherPortal",
    "FeatureFlag",
  ],
  dynamicHeaderTitles: { course: "", student: "", teacher: "" },
  administratorSubjects: {
    filters: {
      searchText: "",
      grades: [],
      tags: [],
      archivalState: "ACTIVE",
      levels: [],
      responseLanguages: [],
    },
  },
  isLoading: {
    bulkUploadActions: false,
  },
  administratorGrades: {
    filters: {
      grades: [],
    },
  },
  eeSubjectsList: {
    filters: {
      searchText: "",
      archivalState: "ACTIVE",
    },
  },
  addEESubjectsModal: {
    filters: {
      searchText: "",
    },
  },
  scrollPosition: 0,
  ibisSessionDetails: {},
  selectedTabValue:
    "" /* This state is being used in the TabSwitcher component in Admin settings */,
  isSidebarRequired: true,
  dialogDetails: {},
  taskProgress: {},
};

export default function myReducer(state = initialState, action) {
  const handler = REDUCER_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}

/**
 * Returns whether a bulk action is in progress for a given module
 * @param {Object} state - Redux state
 * @param {string} modulePrefix - Module identifier, e.g., "student", "staff"
 * @returns {boolean} - true if any task for that module is in progress
 */
export const getIsModuleBulkActionInProgress = (state, modulePrefix) => {
  const taskProgress = _.get(state, "administrator.taskProgress", EMPTY_OBJ);
  return _.some(_.keys(taskProgress), key => _.startsWith(key, modulePrefix));
};
